import { cn } from '@/lib/cn';
import { ResolvedUIConfigWithTest } from '../jsonForms/DisplayJsonUi';
import { DisplayJsonUiField } from '../jsonForms/DisplayJsonUiField';

interface FieldGroupProps {
    fields: ResolvedUIConfigWithTest[];
    data: Record<string, string>;
    autoFocus: boolean;
    disabled: boolean;
    menuPortalTarget?: HTMLElement | null;
}

export const FieldGroupInline: React.FC<FieldGroupProps> = ({ fields, autoFocus, ...fieldProps }) => {

    return (
        <div className='mt-6 first:mt-0 text-textPrimary has-[:disabled]:text-textDisabled flex divide-x ring-inset ring-1 ring-outlinePrimary focus-within:ring-outlineSecondary rounded-input p-px divide-outlinePrimary'>
            {fields.map((field, index) => {
                const isLast = index === fields.length - 1;

                return (
                    <div 
                        key={field.name}
                        className={cn('flex items-center', isLast && 'flex-1')}
                    >
                        <DisplayJsonUiField
                            index={index}
                            field={field as ResolvedUIConfigWithTest}
                            autoFocus={index === 0 && autoFocus}
                            {...fieldProps}
                            className='ring-0'
                            labelClassName='m-0'
                            fieldClassName={cn('m-0', isLast && 'w-full')}
                        />
                    </div>
                );
            })}
        </div>
    );
};
